import * as React from 'react';
import  { withStyles } from '@mui/styles';
import * as request from 'superagent';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';


import { IconButton, Tooltip } from '@mui/material';
import { Menu, MenuItem } from '@mui/material';
// import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { Divider, Tooltip } from '@mui/material';
var Mousetrap = require("mousetrap")
import { Theme } from '@mui/styles';
import * as request from 'superagent';
import { APIError } from '../../lib/types';
// import ConfirmActionModal from '../../../payables/components/modal/confirm-action-modal'
import ProxySelectModal from '~common/components/proxy-select'

import portalUserContext from '~common/lib/portal-user-context';
import ErrorView from '~common/components/error-view';
import classNames from 'classnames';
import Language from '@mui/icons-material/Language'
import translate from '../i18n/i18n'



Mousetrap.prototype.stopCallback = function (e, element) {
  e.preventDefault()
  return false
}


const styles = (theme: Theme): StyleRules => ({
  root: {
    textAlign: 'unset',
    paddingTop: 75,
    paddingLeft: 15,
    paddingRight: 15
    //background: "black url(https://static.boydgaming.net/boydgaming/assets/shell/background.jpg) top no-repeat;",
  },
  toolbar: {
    '@media only print': { display: 'none' }
  },
  flex: {
    flex: 1
  },
  appTitle: {
    flex: 1,
    color: '#fff',
    marginTop: 5,
    fontFamily: 'Arial,san-serif,Helvetica,Trebuchet MS'
  },
  drawerList: {
    width: 250
  },
  menuButton: {
    color: "white",
    marginLeft: -12,
    marginRight: 20
  },
  userPrefButton: {
    color: "white",
    marginLeft: -12,
    marginRight: 20
  },
  logo: {
    marginTop: 0,
    height: 40,
    width: 'auto'
  },
  bottomPadding: {
    height: 60
  },
  chip: {
    margin: theme.spacing()
  },
  homeIcon: {
    marginRight: 10
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
  appBarButton:{}
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
  color?: any
  onLanguageChange?: Function
  options?: any
};

type State = {
  anchorEl?: HTMLElement
  i18nOptions: Array<any>;
//   error?: APIError;
//   showModal?: string;
};

class LanguageButton extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {
      i18nOptions: []
    };
  }

 componentDidMount() {
  request.get("/api/configuration/i18n-list")
  .then((response)=>{
    console.log(response.body)
    if (response && response.body && response.body.options) {
      this.setState({
        i18nOptions: response.body.options
      })
    }
  })
  }

  // UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {
  // }

  handleLanguageClick = (lang:any) => (event:any) => {

    this.setState({
        anchorEl: undefined
    }, this.props.onLanguageChange(lang))
    
  }
  handleAccountMenu = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({
      anchorEl: undefined
    });
  };

  render() {

    const { classes }: { classes: ClassNameMap; } = this.props;
    const {onLanguageChange} = this.props;
    const { anchorEl, i18nOptions } = this.state;
    const open = Boolean(anchorEl);

    
   
    return (
      <div style={{ position: 'relative' }}>
   <Tooltip title="Select preferred language">
   <IconButton
         
          size="large"
          color="primary"
          className={classNames(classes.userPrefButton, classes.menuButton)}
          aria-owns={open ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={this.handleAccountMenu}
        >
          <i  className="fas fa-globe" />
          
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleRequestClose}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&::before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          {i18nOptions.map((o)=>{
            return <MenuItem onClick={this.handleLanguageClick(o.key)} value="es">{o.label}</MenuItem>
          })}
        </Menu>
        </Tooltip>
      </div>
    );
  }
}

export default withStyles(styles)(LanguageButton);


